import { AxiosResponse } from "axios";
import axios from "utils/axios";
import { API_BASE_URL, API_CONTACTS } from "utils/constants";

export type QueryFilters = Record<
  string,
  string | number | boolean | undefined
>;

export interface ContactQuery {
  limit: number;
  query: QueryFilters;
  page: number;
}

export interface ContactEmail {
  type: number;
  email: string;
}

export interface Phone {
  type: number;
  telephone: string;
}

export interface ContactAddress {
  type: number;
  street: string;
  complement: string;
  number: number;
  city: string;
  state: string;
  countryCode: number;
  zipCode: string;
  district: string;
}

export interface Contact {
  id: string;
  name: string;
  nickname?: string;
  emails?: ContactEmail[];
  addresses?: ContactAddress[];
  job?: string;
  birthDay?: string;
  taxDocumentNumber?: string;
  phones: Phone[];
}

export interface ContactQueryResponse {
  totalPages: number;
  totalElements: number;
  entities: Contact[];
}

export interface ContactCountResponse {
  count: number;
}

const getById = (id: string): Promise<AxiosResponse<Contact>> =>
  axios.get<Contact>(`${API_BASE_URL}${API_CONTACTS.BASE_URL}/${id}`);
const save = (contact: Contact): Promise<AxiosResponse<Contact>> =>
  axios.post<Contact>(`${API_BASE_URL}${API_CONTACTS.BASE_URL}`, contact);
const update = (
  id: string,
  contact: Contact
): Promise<AxiosResponse<Contact>> =>
  axios.put<Contact>(`${API_BASE_URL}${API_CONTACTS.BASE_URL}/${id}`, contact);
const remove = (id: string) =>
  axios.delete(`${API_BASE_URL}${API_CONTACTS.BASE_URL}/${id}`);
const query = (
  queryPayload: ContactQuery
): Promise<AxiosResponse<ContactQueryResponse>> =>
  axios.post<ContactQueryResponse>(
    `${API_BASE_URL}${API_CONTACTS.BASE_URL}${API_CONTACTS.QUERY_URL}`,
    queryPayload
  );
const count = (
  queryPayload: ContactQuery
): Promise<AxiosResponse<ContactCountResponse>> =>
  axios.post<ContactCountResponse>(
    `${API_BASE_URL}${API_CONTACTS.BASE_URL}${API_CONTACTS.COUNT_URL}`,
    queryPayload
  );

const contactAPI = {
  getById,
  save,
  update,
  remove,
  query,
  count,
};

export default contactAPI;
